<section class="widget-group">
	<div class="widget-group__content-slider">
		<div class="widget-group__slide-item">
			<app-widget-fines></app-widget-fines>
		</div>
		<div class="widget-group__slide-item">
			<app-widget-tax></app-widget-tax>
		</div>
		@if (isVisibleEducationSubsriptions$ | async) {
			<div class="widget-group__slide-item">
				<app-widget-education></app-widget-education>
			</div>
		}

		@for (item of this.categories; track item) {
			<div class="widget-group__slide-item">
				<app-widget-payment-category
					[categoryId]="item.id"
					[categoryCharges]="item"
				></app-widget-payment-category>
			</div>
		}
	</div>
</section>
